import React from 'react';
import { CTABand } from '../../components/CTABand';
export function AdultFinalCTA() {
  return <CTABand headline="Ready to Try an Adult Class at Storm?" copy="Tell us your goals and experience — a Storm coach will help you choose the right starting class. Beginners welcome, returning students welcome. Call 517-220-0621 or check availability on the form above." data-id="element-533" />;
}